import { render, staticRenderFns } from "./DriverDispatchPage.vue?vue&type=template&id=19c771fa&scoped=true"
import script from "./DriverDispatchPage.vue?vue&type=script&lang=js"
export * from "./DriverDispatchPage.vue?vue&type=script&lang=js"
import style0 from "./DriverDispatchPage.vue?vue&type=style&index=0&id=19c771fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c771fa",
  null
  
)

export default component.exports